/**
 * Shared colour palette for Taiao Waste Management charts.
 * Extracted to a small module to avoid circular import issues.
 */
export const color = [
  '#f26b4b', // Orange
  '#0582bf', // Dark blue
  '#8c7ebb', // Light purple
  '#00a7ca', // Mid teal
  '#473b7b', // Dark purple
  '#66c39b', // Mid green
  '#82afdd', // Mid cornflower
  '#c83c7b', // Dark magenta
  '#86cdae', // Light green
  '#007093', // Dark teal
  '#a8ceee', // Light cornflower
  '#26312b', // Charcoal
  '#00916f', // Dark green
  '#615097', // Mid purple
  '#00b1d8', // Light blue
  '#5fc9de', // Light teal
  '#ee4891', // Mid magenta
  '#6894cd', // Dark cornflower
  '#0395ca', // Mid blue
];

export default { color };
